<template>
  <div class="body-section">
    <v-container>
      <v-row class="mx-auto" style="width:95%">
        <div class="head-info"> 
          <h2 class="mt-4" style="color:#002886;">Tutors</h2>
        </div>   
          <v-container class="mt-2" >
            <div class="searchbox">
              <v-text-field
                v-model="search"
                class="shrink hidden-sm-and-down searchbar"
                width="300"
                height="50"
                placeholder="search for tutor eg: Mukisa John"
                dense
                hide-details
                rounded
                solo
              />
          </div>
            <v-row class="mt-2" v-if="loading">
              <v-col
                  v-for="i in 10"
                  :key="i"
                  cols="12"
                  sm="3"
              >
                <v-skeleton-loader type="image" />
              </v-col>
            </v-row>
            <v-row v-if="!loading && tutors.length">
              <v-col
                  v-for="user in tutors"
                  :key="user.uuid"
                  cols="12"
                  sm="4"
                  v-show="user.profile.first_name || user.profile.last_name"
              >
                <v-card
                    class="mx-auto my-5 mentor-card"
                    width="302px"
                    elevation="0"
                    color="rgba(0, 255, 148, 0.06)"
                    :to="`/mentors/${user.uuid}`"
                >
                <v-card-text class="pa-4">
                  <v-row>
                    <v-col md="4">
                      <v-avatar
                        color="primary"
                        class="mt-4 mx-1"
                        size="50"
                        text-color="white"
                      >
                        <v-img v-if="user.profile.avatar" :src="user.profile.avatar"></v-img>
                        <span v-else class="white--text font-weight-bold">{{user.profile.first_name | initials(user.profile.last_name)}}</span>
                      </v-avatar>
                    </v-col>
                    <v-col md="8" class="pt-7">
                      <h3>{{user.profile.first_name | name(user.profile.last_name)}}</h3>
                      <div class="subject-tags">
                        <span
                          v-for="(subject, i) in user.profile.subjects.slice(0,2)"
                          :key="subject + i"
                          class="subject-tag"
                        >
                          {{subject.name}}
                        </span>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
                
                 
                  <v-row>
                    <v-col class=" mx-5" >
                      <v-card-text class="pa-4">
                        <div class="description-container">
                          <div color="#909090" :class="$vuetify.breakpoint.smAndDown ? 'description-text  text-justify' : '  text-justify description-text'">
                            {{user.profile.biography || description}}
                          </div>
                      </div>
                      </v-card-text>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
              <v-col cols="12">
                <infinite-loading spinner="waveDots" @infinite="fetchMoreTutors">
                  <div slot="no-results">
                    <v-chip small text-color="primary">You have caught up</v-chip>
                  </div>
                  <div slot="no-more">
                    <v-chip small text-color="primary">You have caught up</v-chip>
                  </div>
                </infinite-loading>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" v-if="!loading && !tutors.length">
                <NoData
                    :image="undraw_teacher"
                    title="There are no tutors yet"
                />
              </v-col>
            </v-row>
          </v-container>
      </v-row>
    </v-container>
  </div>
</template>


<script>
import NoData from "@/components/NoData";
import undraw_teacher from "@/assets/undraw_teacher.svg"
import axios from "axios"
import InfiniteScroll from "@/mixins/InfiniteScroll";

export default {
  components: {NoData},
  mixins: [InfiniteScroll],
  metaInfo() {
    return {
      title: "Guiomentor - Tutors",
      url: window.location.href,
    };
  },
  data: () => ({
      undraw_teacher,
      search:"",
      description:"A skilled professional available at your service",
      tutors:[],
      loading:false,
      loadingTutors:false,
      limit: 5,
      offset: 5,
      next: true,
      fetchUrl:''


  }),
  beforeMount(){
    this.fetchUrl = `/users/mentors/?country=UG&limit=${this.limit}`
    this.loadMentors()
    },

    methods: {
        async loadMentors(){
            try {
                this.loading = true;
                let {data}  = await axios.get(this.fetchUrl);
                this.tutors = data.results
                this.loading = false;
            } catch (error) {
                this.loading = false;
            }
        },
      fetchMoreTutors($state) {
        this.infiniteHandler($state, "", false, "tutors")
      },
        randomColor(){
            return '#'+Math.floor(Math.random()*16777215).toString(16);
        }
    },
    filters: {
        name: function(firstname,lastname){
            let fname = firstname?firstname:""
            let lname = lastname?lastname:""
            return fname+" "+lname
        },
        initials: function(firstname,lastname){
            let fname = firstname?firstname.charAt(0).toUpperCase():""
            let lname = lastname?lastname.charAt(0).toUpperCase():""
            return fname+lname
        }
}
};
</script>

<style lang="scss" scoped>
@import "~vuetify/src/styles/settings/_variables";
.description-text{
  color:#909090;  
  margin-top: 5px;
  margin-right: 1.3em;
  overflow: hidden;
  height: 5ch;
  text-overflow: ellipsis;

  
}
.subject-tags{
  overflow: auto;
  width: 100%;
  float: left;
  white-space: nowrap;
}
.subject-tags::-webkit-scrollbar {
  display: none;
}
.subject-tag{
  font-size:0.8em;
  padding-right: 0.4em;
}

.description{
  color:#909090;
  font-size: 0.8em;
  line-height: 1em;
  
}
.suggested-mentor-card{
  padding-bottom: 20px;
  width: 230px;
  border-bottom: 1px solid #CFCFCF;

}
.mentor{
  color:#909090;
  font-size: 13px;
}
.mentor-name{
  margin-top: 3px;
  font-style: normal;
  font-weight: 700;
  font-size: 17px;
  line-height: 17px;
}
.visit{
  border-radius: 22px;
  font-size: 12px;
  text-transform:none;
}
.follow{
  border-radius: 0.8em;
  font-size: 12px;
  text-transform:uppercase;
}
.body-section {
  height: 85vh;
  margin-top: 4.5em;
  overflow-y:auto;
  display: flex;
  flex-direction: column;
  border-radius: 1em;
  background-color: #f5f6f8;
  background-color: white;
}
.head-info{
  position: sticky;
  top:0px;
  background-color: white;
  width: 100%;
  z-index: 5;
}
.suggested-side{
  border-left: 1px solid #CFCFCF;
  height: 100%;
  padding-left: 20px;
}

.searchbox{
    width:550px;
    margin:auto;
}
.centered-section {
  background: var(--v-primary-base);
  min-height: 35vh;
}
.mentor-card{
  border-radius: 11px;
}

.subject-icon {
  font-size: 1.5rem;
  font-weight: bold;
}
@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .centered-section {
    margin: 0 !important;
  }
  .suggested-side{
    border-left: none;
  }
  .add-margin-bottom-on-mobile {
    margin-bottom: 3em;
  }
  .body-section {
    margin-top: 8em;
  }
}
</style>
